import { format, parse } from 'date-fns';

export const parseDateTime = (value: string | undefined): Date | undefined =>
  value ? parse(value, 'yyyy-MM-dd HH:mm:ss', new Date()) : undefined;

export const formatDateTime = (
  value: string | undefined,
  formatString: string,
) => {
  const date = parseDateTime(value);
  return date ? format(date, formatString) : undefined;
};

export const parseDate = (value: string | undefined): Date | undefined =>
  value ? parse(value, 'yyyy-MM-dd', new Date()) : undefined;

export const formatDate = (value: string | undefined, formatString: string) => {
  const date = parseDate(value);
  return date ? format(date, formatString) : undefined;
};

export const formatTimePeriod = (value: number): string => {
  const period = value < 12 || value === 24 ? '오전' : '오후';
  const time = value > 12 ? value - 12 : value;
  return `${period} ${time}시`;
};

export const formatTimeCode = (timeCode: string): string => {
  if (!timeCode || typeof timeCode === 'number') return '';
  const value = Number(timeCode.substring(1));
  const period = value < 12 || value === 24 ? '오전' : '오후';
  const time = value > 12 ? value - 12 : value;
  return `${period} ${time}시`;
};
